<template>
  <div>
    <div v-if="searchBar" class="row">
      <div class="col-xxl-10 col-xl-10 col-lg-10 col-md-8">
        <button v-if="isAnyFilterSelected" id="reset_filter" data-test="reset_filter" class="btn bg-primary btn-sm text-white ms-2" @click="resetFilter">
          {{ $t('network.resetFilter') }}
        </button>
      </div>
    </div>
    <b-overlay :show="busy">
      <CourseCardView :columns="[showSidebar ? 3 : 6]" :courses="filteredCourses" :network="network" :displaySize="displaySize" />
    </b-overlay>
    <div v-if="busy" class="text-center">
      <lottie-player
        autoplay
        loop
	      speed="2.5"
        src="/img/animations/custom_loader.json"
        style="height: 130px;"
        >
      </lottie-player>
      <p id="cancel-label">{{ $t('network.fetchingMore') }}</p>
    </div>
    <div v-if="pagination.reached_end && filteredCourses.length" class="row mt-3">
      <div class="text-secondary text-center">{{ $t('network.presenters.reachedEndOfTheList') }}</div>
    </div>
    <div v-if="!filteredCourses.length && !busy" class="card shadow-lg text-center pb-4 mx-4">
      <div class="card-body pb-0">
        <svg width="357" height="283" viewBox="0 0 357 283" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 250px; height: auto;">
          <path d="M37.1123 99.9785L0 163.807V46.3125C0 31.4893 12.0082 19.4375 26.7778 19.4375H75.9401C83.0529 19.4375 89.8729 22.251 94.8937 27.29L105.981 38.418C111.002
          43.457 117.822 46.2705 124.935 46.2705H174.056C188.825 46.2705 200.833 58.3223 200.833 73.1455V86.583H60.25C50.7104 86.583 41.924 91.6641 37.1123
          99.9365V99.9785ZM48.6602 106.739C51.087 102.582 55.4802 100.062 60.25 100.062H227.611C232.423 100.062 236.816 102.624 239.201 106.823C241.586 111.022 241.586
          116.146 239.159 120.303L192.298 200.928C189.913 205.043 185.52 207.562 180.75 207.562H13.3889C8.57726 207.562 4.18403 205.001 1.79913 200.802C-0.585764 196.603
          -0.585764 191.479 1.84097 187.322L48.7021 106.697L48.6602 106.739Z" fill="#959494"/>
          <path d="M106 174.5L143.5 137C146.261 134.239 146.261 129.761 143.5 127C140.739 124.239 136.261 124.239 133.5 127L96 164.5C93.2386 167.261 93.2386 171.739 96
          174.5C98.7614 177.261 103.239 177.261 106 174.5Z" fill="white"/>
          <path d="M106 127L143.5 164.5C146.261 167.261 146.261 171.739 143.5 174.5C140.739 177.261 136.261 177.261 133.5 174.5L96 137C93.2386 134.239 93.2386 129.761 96
          127C98.7614 124.239 103.239 124.239 106 127Z" fill="white"/>
          <g filter="url(#filter0_d_208_270)">
          <path d="M293.932 46.3272L283.774 94.4366L331.943 104.606L293.932 46.3272ZM271.74 91.8957L281.897 43.7863L215.706 29.8113C210.919 28.8033 205.927 29.7369
          201.828 32.4071C197.728 35.0773 194.856 39.2657 193.843 44.052L160.811 200.503C159.803 205.29 160.737 210.282 163.407 214.382C166.077 218.481 170.266 221.353
          175.052 222.366L283.364 245.235C285.737 245.739 288.185 245.772 290.57 245.329C292.955 244.887 295.229 243.979 297.262 242.657C299.295 241.335 301.048 239.624
          302.42 237.624C303.792 235.624 304.756 233.373 305.257 231L329.396 116.67L281.57 106.573C279.953 106.27 278.413 105.647 277.04 104.741C275.667 103.836 274.488
          102.665 273.573 101.299C272.657 99.9318 272.024 98.3963 271.709 96.7818C271.394 95.1672 271.405 93.5061 271.74 91.8957Z" fill="#959494"/>
          <path d="M175.04 133.16L211.272 124.539L249.958 148.977L287.981 140.734L319.06 165.478L317.525 172.748L287.336 150.083L247.841 158.036L210.168 134.127L173.119
          142.259L175.04 133.16Z" fill="#FAFAFA"/>
          </g>
          <defs>
          <filter id="filter0_d_208_270" x="119.915" y="0.915039" width="236.528" height="281.224" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="7" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_208_270"/>
          <feOffset dx="-8" dy="4"/>
          <feGaussianBlur stdDeviation="12.75"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_208_270"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_208_270" result="shape"/>
          </filter>
          </defs>
        </svg><br>
        <span class="fw-semibold">
          {{ $t('network.member.noResultsToShow') }}.
          {{ $t('try-searching-with-a-different-keyword-or-filter') }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import CourseCardView from './views/CourseCardView.vue';
import infiniteScroll from 'vue-infinite-scroll';

export default {
  name: 'ResultCourseSection',
  components: {
    CourseCardView,
  },
  directives: { infiniteScroll },
  props: {
    showSidebar: {
      type: Boolean,
      default: false,
    },
    searchBar: {
      type: Boolean,
      default: true,
    },
    courses_view: {
      type: Array,
      default: null,
    },
    network: {
      type: [Object, Array],
      default: null,
    },
    filteredCourses: {
      type: Array,
      default: null,
    },
    displaySize: {
      type: String,
      default: null,
    },
    busy: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: null,
      limit: 20,
      offset: 0,
      reached_end: false,
    },
    isAnyFilterSelected: {
      type: Boolean,
      default: false,
    },
    isFiltered: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      coursesViewType: 'card',
    };
  },
  methods: {
    loadMore() {
      this.$emit('loadMore');
    },
    resetFilter() {
      alert('implement it here');
    },
  },
};
</script>
